<template>
	<div class="s-gray-bg" style="min-height:100vh;padding-top: 1rem;">
		<loadingContent v-if="isPullDown"></loadingContent>
		<ul class="p-margin20 p-padding20  p-white-bg p-radius20 p-black" style="width: auto;"
			v-if="Object.keys(nibpReportListJson).length>0">
			<template>
				<div v-for="(val,key,index) in nibpReportListJson" :key="key" >
						<div class="p-space-between p-box-center-y p-padding-top10" @click="goToNibpReprotDetail(val)" >
							<span class="p-space-between p-box-center-y  p-color6-border  "
								:class="(key===(Object.keys(nibpReportListJson).length-1))?'p-border-none':'p-border2'"
								style="width:calc(100% ); padding:0.3rem 0rem 1rem 0rem;">

								<div class="p-space-between p-box-center-y p-font0-8">
									<div class="p-font1-2">
										{{val.avgsys+'/'+val.avgdia}}
									</div>
									<span class="p-color3 p-font0-7" style="margin-left: 0.5rem;margin-top: 0.1rem;">{{$t('measure.mmHg')}}</span>
								</div>



								<div class="p-font0-9 p-color1 p-box-center" style="margin-top: 0.1rem;">
									<!-- <div class="p-font1 p-color1">血压：{{ v.sys  }}/{{ v.dia  }} {{ v.result  }}<text class="p-color3">mmHg</text></div> -->
									{{ time(val.sts).format('YYYY.MM.DD')+'-'+time(val.ets).format('YYYY.MM.DD')   }}
								</div>
								<span class="p-color3 p-font0-7" style="margin-left: 0.5rem;">{{val.status==1?$t('measure.reportductIng'):(val.readflag==1?$t('measure.readed'):$t('measure.unread'))}}</span>
								<img src="../assets/img/arrow_gray_right.png">
								</img>
							</span>
						</div>
				</div>
			</template>
		</ul>

		<div v-if="isShowBottom" class="p-line-height3 p-font0-8 p-color3 p-center">{{ $t('common.nowLoadingMoreData') }}</div>
		<loadingContent v-else-if="isLoading"></loadingContent>
		<noContent v-else-if="Object.keys(nibpReportListJson).length<=0"></noContent>
		<loadedAllData v-else-if="(!isPullDown && !isLoading) && isBottom"></loadedAllData>
	</div>
</template>

<script>
	import loadingContent from "../components/loading/loadingContent";
	import noContent from "../components/loading/noContent";
	import loadedAllData from "../components/loading/loadedAllData";
	import mixins from '@/utils/mixins.js'
	import {
		mapState
	} from 'vuex'
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			loadingContent,
			noContent,
			loadedAllData,
		},
		data() {
			return {
				title: '',
				lastTime: '', // 用于滚动加载
				isBottom: false, // 滚动到底，没有更多数据
				isLoading: false,
				isNoData: false, // 没有数据
				isPullDown: false,
				isShowBottom:false,
			}
		},
		methods: {
			// 返回时间数据时触发：获取点集。时间发送变化时，点集也发生变化。多个图时，需要多次请求-------------------------------------------------------------------------
			goToNibpReprotDetail(tempValue){
				
			},
			// 获取不同类型数据
			getData() {
				this.getNibpReportHistoryList();
			},

		},
		created() {
			document.title = this.$t('measure.bloodPressureReport')
			this.getData();
		},
		onLoad(query) {
			this.query = query;

		    console.log("this.query: ", this.query);
			// uni.setNavigationBarTitle({
			// 	title: this.query.uname ? (decodeURI(this.query.uname) + '的' + this.typeJson[this.query
			// 		.dataType]) : this.typeJson[this.query.dataType]
			// });


			// if (this.query.toggleNum) this.toggleNum = Number(this.query.toggleNum);


			// 初始化操作、网页传参---------------------------------------------------------------------------------------------------------
			// http://192.168.31.35:8080/madara_page/#/pages/list?dataType=BP&pid=14440&uname=%E6%9D%A8%E7%A7%91
			// if (this.query.dataType === 'SN') {
			// 	this.lastTime = Number(this.query.ets) || '2100-01-01 00:00:01'; // 用于滚动加载
			// } else {
			this.lastTime = Number(this.query.ets) || -1; // 用于滚动加载
			// }
			this.getData();
		},
		// onReachBottom() {
		// 	this.getData();
		// },

	}
</script>

<style scoped>

</style>
